package flagpack.icons.small

import androidx.compose.foundation.Image
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.padding
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.PathData
import androidx.compose.ui.graphics.vector.group
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import flagpack.icons.FlagIcons
import org.jetbrains.compose.ui.tooling.preview.Preview

/**
 * Bangladesh Flag (16x12dp)
 *
 * - ISO Alpha-2: BD
 * - ISO Alpha-3: BGD
 * - ISO Numeric: 050
 *
 * @see [Flagpack](https://flagpack.xyz)
 */
public val FlagIcons.Small.Bangladesh: ImageVector by lazy {
    ImageVector.Builder(
        name = "Bangladesh:BD:BGD:050:Small",
        defaultWidth = 16.dp,
        defaultHeight = 12.dp,
        viewportWidth = 16f,
        viewportHeight = 12f
    ).apply {
        group(
            clipPathData = PathData {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
        ) {
            path(fill = SolidColor(Color.White)) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(fill = SolidColor(Color(0xFF38A17E))) {
                moveTo(0f, 0f)
                horizontalLineToRelative(16f)
                verticalLineToRelative(12f)
                horizontalLineToRelative(-16f)
                close()
            }
            path(
                fill = SolidColor(Color(0xFFF72E45)),
                pathFillType = PathFillType.EvenOdd
            ) {
                moveTo(6f, 9f)
                curveTo(7.657f, 9f, 9f, 7.657f, 9f, 6f)
                curveTo(9f, 4.343f, 7.657f, 3f, 6f, 3f)
                curveTo(4.343f, 3f, 3f, 4.343f, 3f, 6f)
                curveTo(3f, 7.657f, 4.343f, 9f, 6f, 9f)
                close()
            }
        }
    }.build()
}

@Preview
@Composable
private fun BangladeshPreview() {
    Box(modifier = Modifier.padding(12.dp)) {
        Image(
            imageVector = FlagIcons.Small.Bangladesh,
            contentDescription = "Bangladesh Flag"
        )
    }
}
